module.exports = __webpack_public_path__ + "img/AppBlockingOutlined.a237396c.svg";